import DashboardService from "../../../services/DashboardService";

const state = {
  startDate: null,
  endDate: null,
  location: null,
  user: null,
  invitationDetail : {
    type: "",
    data: {
      invitations: [],
      page: 1,
      per_page: 10,
      total_count: 0,
      total_pages: 0
    },
    isLoading: false,
    error: null
  }
};

const getters = {
  getStartDate(state) {
    return state.startDate;
  },
  getEndDate(state) {
    return state.endDate;
  },
  getLocation(state) {
    return state.location;
  },
  getUser(state) {
    return state.user;
  },
  getSelectedInvitation(state){
    return state.invitationDetail
  },
  getInvitationParams(state) {
    return {
      type: state.invitationDetail.type,
      location_id: state.location || null,
      start_date: state.startDate || null,
      end_date: state.endDate || null
    }
  }
};

const mutations = {
  setRangeDate(state, {start, end}) {
    state.endDate = end;
    state.startDate = start;
  },
  setLocation(state, location) {
    state.location = location;
  },
  setUser(state, user) {
    state.user = user;
  },
  setInvitationDetailData(state, data){
    state.invitationDetail.data = data;
    state.invitationDetail.error = null;
  },
  setInvitationDetailType(state, type){
    state.invitationDetail.type = type;
  },
  setInvitationDetailLoading(state, value){
    state.invitationDetail.isLoading = value;
  },
  setInvitationDetailError(state, error){
    state.invitationDetail.error = error;
    state.invitationDetail.data = null;
  }
}

const actions = {

  async fetchInvitationDetails({ commit, getters}, params) {
    
    commit("setInvitationDetailLoading", true)

    try {

      const invitationParams = params || getters.getInvitationParams;


      if(!invitationParams.type){
        return 
      }

      const data = await DashboardService.getInvitationsDetailByType(invitationParams)

      commit('setInvitationDetailData', data);


    } catch (error) {

      commit("setInvitationDetailError", "No es posible obtener los datos, intenta mas tarde.")

      commit('setInvitationDetailData', null);

      
    } finally {

      commit("setInvitationDetailLoading", false)

    }

  }
};

export default {
  state,
  getters,
  mutations,
  actions
};